import axios from 'axios'
import authHeader from './auth-header'
import Config from '../../config'
import Vue from "vue"

if (localStorage.getItem('apiServers')) {
  Vue.prototype.$apiServers = JSON.parse(localStorage.getItem('apiServers'))
} else {
  Vue.prototype.$apiServers = Config.apiServers
}

class PaymentService {
  /**
   * بررسی وضعیت درگاه پرداخت
   */
  getStatus() {
    return axios.post(`${Vue.prototype.$apiServers.url}/payment/status`, {}, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * درخواست پرداختِ تمدید
   * @param {Object} data - { deviceIds: [], planId, useWallet }
   */
  requestPayment(data) {
    return axios.post(`${Vue.prototype.$apiServers.url}/payment/request`, data, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * دریافت لیست تراکنش‌های کاربر
   * @param {Object} data - { page, limit, status }
   */
  getList(data = {}) {
    return axios.post(`${Vue.prototype.$apiServers.url}/payment/list`, data, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * دریافت جزئیات یک تراکنش
   * @param {Object} data - { paymentId }
   */
  getDetail(data) {
    return axios.post(`${Vue.prototype.$apiServers.url}/payment/detail`, data, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * دریافت آمار تراکنش‌های کاربر
   */
  getStats() {
    return axios.post(`${Vue.prototype.$apiServers.url}/payment/stats`, {}, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * داده‌ی صفحه‌ی تمدید: پلن‌ها، دستگاه‌ها (با پیش‌نمایشِ تاریخِ بعد از تمدید)، موجودیِ کیف پول، وضعیتِ درگاه
   */
  getOptions() {
    return this.post('/payment/options')
  }

  /**
   * نتیجه‌ی یک پرداخت با کدِ پیگیری
   * @param {Object} data - { ref }
   */
  getResult(data) {
    return this.post('/payment/result', data)
  }

  // ---- کیف پول ----

  getWallet() {
    return this.post('/wallet')
  }

  /**
   * @param {Object} data - { page, limit }
   */
  getWalletTransactions(data = {}) {
    return this.post('/wallet/transactions', data)
  }

  /**
   * شارژ کیف پول
   * @param {Object} data - { amount } به تومان
   */
  topupWallet(data) {
    return this.post('/wallet/topup', data)
  }

  post(path, data = {}) {
    return axios.post(`${Vue.prototype.$apiServers.url}${path}`, data, { headers: authHeader() })
      .then(response => response.data)
  }

  // ---- متدهای ادمین ----

  /**
   * @param {Object} data - { paymentId }
   */
  reverify(data) {
    return this.post('/admin/payment/reverify', data)
  }

  /**
   * @param {Object} data - { paymentId }
   */
  renewRetry(data) {
    return this.post('/admin/payment/renew-retry', data)
  }

  getWalletStats() {
    return this.post('/admin/wallet/stats')
  }

  /**
   * @param {Object} data - { search }
   */
  getWalletList(data = {}) {
    return this.post('/admin/wallet/list', data)
  }

  /**
   * @param {Object} data - { customerId, page, limit }
   */
  getWalletLedger(data) {
    return this.post('/admin/wallet/ledger', data)
  }

  /**
   * @param {Object} data - { customerId, amount (تومان، منفی = کاهش), reason }
   */
  adjustWallet(data) {
    return this.post('/admin/wallet/adjust', data)
  }

  /**
   * دریافت تنظیمات درگاه (ادمین)
   */
  getConfig() {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/payment/config`, {}, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * ذخیره تنظیمات درگاه (ادمین)
   * @param {Object} data - { merchantId, terminalId, terminalKey, environment, callbackUrl }
   */
  saveConfig(data) {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/payment/config/save`, data, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * فعال/غیرفعال کردن درگاه (ادمین)
   * @param {Object} data - { enabled: boolean }
   */
  toggleGateway(data) {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/payment/toggle`, data, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * تست اتصال به درگاه (ادمین)
   */
  testConnection() {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/payment/test`, {}, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * دریافت لیست همه تراکنش‌ها (ادمین)
   * @param {Object} data - { page, limit, status, search, startDate, endDate }
   */
  getAdminList(data = {}) {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/payment/list`, data, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * دریافت آمار کلی تراکنش‌ها (ادمین)
   * @param {Object} data - { startDate, endDate }
   */
  getAdminStats(data = {}) {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/payment/stats`, data, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * دریافت جزئیات تراکنش (ادمین)
   * @param {Object} data - { paymentId }
   */
  getAdminDetail(data) {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/payment/detail`, data, { headers: authHeader() })
      .then(response => response.data)
  }

  /**
   * خروجی اکسل (ادمین)
   * @param {Object} data - { status, startDate, endDate }
   */
  exportExcel(data = {}) {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/payment/export`, data, { headers: authHeader() })
      .then(response => response.data)
  }
}

export default new PaymentService()
